import { AttackTypeEnum } from "../types";

export const bulletColors = new Map([
  [AttackTypeEnum.GRASS, "#38a169"],
  [AttackTypeEnum.FIRE, "#e53e3e"],
  [AttackTypeEnum.WATER, "#3182ce"],
  [AttackTypeEnum.ROCK, "#B5A04B"],
  [AttackTypeEnum.ELECTRIC, "#FBF953"],
  [AttackTypeEnum.POISON, "#A672B1"],
  [AttackTypeEnum.GROUND, "#AE9356"],
  [AttackTypeEnum.PSYCHIC, "#BB81A7"],
  [AttackTypeEnum.BUG, "#C9CF7B"],
  [AttackTypeEnum.FLYING, "#B2B399"],
  [AttackTypeEnum.NORMAL, "#79776F"],
]);
